import axios from "axios";
import {
   EVENT_LIST,
   ADD_EVENT_LIST,
   EVENT_REGISTRATIONS,
   EVENT_REGISTRATIONS_EXPORT,
   EVENT_DETAILS,
   EVENT_PAYMENT_REVERIFY,
} from "../../constant/API constant";

export const fetchEventsList = (paramsObj) => {
   const jwt_token = localStorage.getItem("token");
   return axios.get(`${process.env.REACT_APP_API_URL}${EVENT_LIST}`, {
      headers: { Authorization: jwt_token },
      params: paramsObj,
   });
};

export const createEvent = (formData) => {
   const jwt_token = localStorage.getItem("token");
   return axios.post(
      `${process.env.REACT_APP_API_URL}${ADD_EVENT_LIST}`,
      formData,
      {
         headers: { Authorization: jwt_token },
      }
   );
};

export const updateEventApi = (eventId, formData) => {
   const jwt_token = localStorage.getItem("token");
   return axios.put(
      `${process.env.REACT_APP_API_URL}${EVENT_LIST}`,
      formData,
      {
         headers: { Authorization: jwt_token },
         params: { eventId }
      }
   );
};

export const fetchEventRegistrations = (paramsObj) => {
   const jwt_token = localStorage.getItem("token");
   return axios.get(`${process.env.REACT_APP_API_URL}${EVENT_REGISTRATIONS}`, {
      headers: { Authorization: jwt_token },
      params: paramsObj,
   });
};

export const fetchEventDetail = (paramsObj) => {
   const jwt_token = localStorage.getItem("token");
   return axios.get(`${process.env.REACT_APP_API_URL}${EVENT_DETAILS}`, {
      headers: { Authorization: jwt_token },
      params: paramsObj,
   });
};

export const fetchPublicEventDetail = (eventUuid) => {
   return axios.get(`${process.env.REACT_APP_API_URL}/hisab-kitab/public/api/v1/event/detail`, {
      params: { eventUuid }
   });
};

export const fetchEventRegistrationDetail = (registrationIdOrUuid) => {
   const jwt_token = localStorage.getItem("token");
   const params = {};
   if (typeof registrationIdOrUuid === "string" && registrationIdOrUuid.includes("-")) {
      params.uuid = registrationIdOrUuid;
   } else {
      params.id = registrationIdOrUuid;
   }
   return axios.get(`${process.env.REACT_APP_API_URL}/hisab-kitab/api/v1/event/registration/detail`, {
      headers: { Authorization: jwt_token },
      params
   });
};

export const exportEventRegistrations = (paramsObj) => {
   const jwt_token = localStorage.getItem("token");
   return axios.get(`${process.env.REACT_APP_API_URL}${EVENT_REGISTRATIONS_EXPORT}`, {
      headers: { Authorization: jwt_token },
      params: paramsObj,
      responseType: "arraybuffer",
   });
};

export const verifyEventPayment = (payload) => {
   return axios.post(`${process.env.REACT_APP_API_URL}/hisab-kitab/public/api/v1/event/payment/verify`, payload);
};

export const failEventPayment = (payload) => {
   return axios.post(`${process.env.REACT_APP_API_URL}/hisab-kitab/public/api/v1/event/payment/failed`, payload);
};

export const updateEventRegistration = (payload) => {
   const jwt_token = localStorage.getItem("token");
   return axios.put(`${process.env.REACT_APP_API_URL}/hisab-kitab/api/v1/event/registration`, payload, {
      headers: { Authorization: jwt_token }
   });
};

export const fetchEventAccessUsers = () => {
   const jwt_token = localStorage.getItem("token");
   return axios.get(`${process.env.REACT_APP_API_URL}/hisab-kitab/api/v1/event/access-users`, {
      headers: { Authorization: jwt_token }
   });
};

export const updatePublicEventRegistration = (payload) => {
   return axios.put(`${process.env.REACT_APP_API_URL}/hisab-kitab/public/api/v1/event/registration`, payload);
};

export const reverifyEventPayment = (payload) => {
   const jwt_token = localStorage.getItem("token");
   return axios.post(`${process.env.REACT_APP_API_URL}${EVENT_PAYMENT_REVERIFY}`, payload, {
      headers: { Authorization: jwt_token }
   });
};

